import React from 'react';

import { getDeviceColor } from '../constants';

import { TrapStatus } from 'api/InteractiveMap/types';

interface Props {
  caughtPests: number;
  status: TrapStatus;
  number: string | number;
  activityLabel?: string;
}

const SRSTSvg: React.FC<Props> = ({ caughtPests, status, number, activityLabel }) => {
  const color = getDeviceColor(status);
  const counterFontSize = 12;
  const setLeftOffset = (num: string) => {
    switch (num.length) {
      case 1:
        return '30%';
      case 2:
        return '25%';
      case 3:
        return '17%';
      default:
        return '0%';
    }
  };
  const textColor = status === TrapStatus.warning ? 'black' : 'white';
  return (
    <div style={{ position: 'relative', width: '50px', height: '50px' }}>
      <span
        style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: 'black',
          position: 'absolute',
          top: '0px',
          left: setLeftOffset(number ? number.toString() : ''),
          transform: `translateX(-${setLeftOffset(number ? number.toString() : '')})`,
        }}
      >
        <text x="50%" y="45%" textAnchor="middle" fill="#000" fontSize="12">
          {number}
        </text>
      </span>
      <svg
        width="40"
        height="30"
        viewBox="0 0 34 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'absolute', bottom: '0px', left: '50%', transform: 'translateX(-50%)' }}
      >
        <path
          d="M15.5562 1.41406L20.2702 6.12811L15.5562 10.8422L20.2702 15.5562L15.5562 20.2702L11.7 16.4141H9.98429L6.12811 20.2702L1.41406 15.5562L6.12811 10.8422L1.41406 6.12811L6.12811 1.41406L10.1281 5.41406H11.5562L15.5562 1.41406Z"
          fill={color}
        />
        <path
          d="M21.6846 6.12793L16.9707 10.8418L21.6846 15.5566L15.5566 21.6846L11.2861 17.4141H10.3984L6.12793 21.6846L0 15.5566L4.71387 10.8418L0 6.12793L6.12793 0L10.542 4.41406H11.1416L15.5566 0L21.6846 6.12793ZM11.5566 5.41406H10.1279L6.12793 1.41406L1.41406 6.12793L6.12793 10.8418L1.41406 15.5566L6.12793 20.2705L9.98438 16.4141H11.7002L15.5566 20.2705L20.2705 15.5566L15.5566 10.8418L20.2705 6.12793L15.5566 1.41406L11.5566 5.41406Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.769 17.6904C30.6774 17.5336 30.7296 17.3311 30.8753 17.2264C31.7981 16.5627 32.3469 15.5133 32.3469 14.2935C32.3469 11.9678 30.6634 10.4121 28.2607 10.4121H24.0178C23.8424 10.4121 23.7002 10.5584 23.7002 10.739V21.0853C23.7002 21.2658 23.8424 21.4121 24.0178 21.4121H26.1832C26.3586 21.4121 26.5008 21.2658 26.5008 21.0853V18.3447C26.5008 18.1642 26.643 18.0178 26.8184 18.0178H27.8124C27.9284 18.0178 28.0352 18.083 28.0909 18.1877L29.716 21.2422C29.7718 21.347 29.8786 21.4121 29.9946 21.4121H32.3821C32.6291 21.4121 32.7816 21.1347 32.6543 20.9168L30.769 17.6904ZM26.8184 15.5821C26.643 15.5821 26.5008 15.4358 26.5008 15.2553V13.2218C26.5008 13.0413 26.643 12.895 26.8184 12.895H28.123C28.9953 12.895 29.5156 13.3978 29.5156 14.2307C29.5156 15.0793 28.9953 15.5821 28.123 15.5821H26.8184Z"
          fill={color}
        />
        <path
          d="M28.2607 9.41211C29.679 9.41211 30.958 9.874 31.8906 10.7529C32.8287 11.6369 33.3467 12.8789 33.3467 14.2939C33.3466 15.6219 32.8227 16.8129 31.9121 17.6641L33.5176 20.4121C34.0092 21.2535 33.4503 22.4121 32.3818 22.4121H29.9941C29.4983 22.4119 29.0574 22.1337 28.833 21.7119L27.501 19.207V21.085C27.501 21.7903 26.938 22.4119 26.1836 22.4121H24.0176C23.2631 22.412 22.7002 21.7904 22.7002 21.085V10.7393C22.7002 10.0338 23.2631 9.41222 24.0176 9.41211H28.2607ZM24.0176 10.4121C23.8423 10.4122 23.7002 10.5588 23.7002 10.7393V21.085C23.7002 21.2654 23.8423 21.412 24.0176 21.4121H26.1836C26.3588 21.4119 26.501 21.2653 26.501 21.085V18.3447C26.501 18.1642 26.643 18.0176 26.8184 18.0176H27.8125C27.9284 18.0176 28.0351 18.0829 28.0908 18.1875L29.7158 21.2422C29.7715 21.3468 29.8783 21.4119 29.9941 21.4121H32.3818C32.6288 21.4121 32.7814 21.1348 32.6543 20.917L30.7686 17.6904C30.6771 17.5338 30.7296 17.3314 30.875 17.2266C31.7976 16.563 32.3466 15.5135 32.3467 14.2939C32.3467 11.9682 30.6634 10.4121 28.2607 10.4121H24.0176ZM28.123 12.8945C28.9953 12.8945 29.5155 13.3978 29.5156 14.2305C29.5156 15.079 28.9953 15.582 28.123 15.582H26.8184C26.643 15.582 26.501 15.4354 26.501 15.2549V13.2217C26.5011 13.0412 26.643 12.8945 26.8184 12.8945H28.123ZM27.501 14.582H28.123C28.367 14.582 28.4413 14.5153 28.4502 14.5068C28.4537 14.5034 28.5156 14.4476 28.5156 14.2305C28.5156 14.0264 28.4567 13.9751 28.4531 13.9717C28.4441 13.9631 28.3687 13.8945 28.123 13.8945H27.501V14.582Z"
          fill="black"
        />
        <text
          x="11"
          y="12"
          textAnchor="middle"
          dominantBaseline="middle"
          fill={textColor}
          fontWeight="bold"
          fontSize={counterFontSize}
          style={{ fontFamily: 'sans-serif' }}
        >
          {activityLabel ? activityLabel : caughtPests || '0'}
        </text>
      </svg>
    </div>
  );
};

export default SRSTSvg;
